import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import { usePlayerContext } from "../../context/PlayerContext";
import {Close} from "../Icons/IconPackage/Close";
import "./style.scss";

export const EVENT_GET_PARENT_SCROLL = 'getScrollPosition';

const updateDragRestrictions = (dragRestrictions, rect) => {
    if (rect.width !== dragRestrictions.rect.width) {
        const diff = (rect.width - dragRestrictions.rect.width) / 2;
        dragRestrictions = {
            ...dragRestrictions,
            left: dragRestrictions.left + diff,
            right: dragRestrictions.right - diff,
            rect: {
                width: dragRestrictions.rect.height,
                height: rect.width,
            },
        };
    }
    if (rect.height !== dragRestrictions.rect.height) {
        const diff = (rect.height - dragRestrictions.rect.height) / 2;
        dragRestrictions = {
            ...dragRestrictions,
            top: dragRestrictions.top + diff,
            bottom: dragRestrictions.bottom - diff,
            rect: {
                width: dragRestrictions.rect.width,
                height: rect.height,
            },
        };
    }

    return dragRestrictions;
}

export default ({children, isOpen, onClose, header, title, isCloseOut, isAbsoluteDisplay, isMoving, onCloseCheck, isWidget = false}) => {
    const { tabletView } = usePlayerContext();
    const [isDragging, setIsDragging] = useState(false);
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });
    const dragStartPos = useRef({ x: 0, y: 0 });
    const modalRef = useRef(null);
    const dragRestrictionsRef = useRef(null);

    const handleMouseDown = (e) => {
        if (!isMoving || tabletView) {
            return;
        }

        dragStartPos.current = { x: e.clientX, y: e.clientY };
        if (modalRef.current) {
            const rect = modalRef.current.getBoundingClientRect();
            dragRestrictionsRef.current = updateDragRestrictions(dragRestrictionsRef.current, rect);
        }

        setIsDragging(true);
    };

    /** БЛОК ДЛЯ ПОЗИЦИОНИРОВАНИЯ ПОП-АПА В ВИДЖЕТЕ */
    useEffect(() => {
        if (window.self === window.top) {
            return;
        }

        window.addEventListener('message', handleParentMessage);

        return () => {
            window.removeEventListener('message', handleParentMessage);
        };
    }, []);

    useEffect(() => {
        if (window.self === window.top) return;

        window.parent.postMessage({event: EVENT_GET_PARENT_SCROLL}, '*');
    }, [isOpen]);

    function handleParentMessage(event) {
        if (!event.data.hasOwnProperty('name') || event.data.name !== EVENT_GET_PARENT_SCROLL || !modalRef.current) {
            return;
        }

        const _style = {
            position: 'fixed',
        }

        const modalRect = modalRef.current.getBoundingClientRect();
        const {height: parentHeight, frameRect} = event.data;
        let offsetTop = ((parentHeight - modalRect.height) / 2) - frameRect.top;

        if (offsetTop < 0) {
            offsetTop = 20;
        }
        
        if (offsetTop + modalRect.height > window.innerHeight) {
            _style.bottom = 20;
        } else {
            _style.top = offsetTop;
        }

        setModalPosition((prev) => ({ ...prev, ..._style }));
    }
    /** КОНЕЦ БЛОКА */

    useEffect(() => {
        setModalPosition({ x: 0, y: 0 });

        dragStartPos.current = { x: 0, y: 0 };
        if (modalRef.current) {
            const rect = modalRef.current.getBoundingClientRect();
            dragRestrictionsRef.current = {
                left: -rect.left,
                top: -rect.top,
                right: rect.right - rect.width,
                bottom: rect.bottom - rect.height,
                rect: {
                    width: rect.width,
                    height: rect.height,
                },
            };
        }
    }, [isOpen]);

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (isDragging && dragRestrictionsRef.current) {
                const deltaX = e.clientX - dragStartPos.current.x;
                const deltaY = e.clientY - dragStartPos.current.y;
                const { left, top, right, bottom } = dragRestrictionsRef.current;
                setModalPosition((prev) => {
                    const x = Math.min(Math.max(prev.x + deltaX, left), right);
                    const y = Math.min(Math.max(prev.y + deltaY, top), bottom);

                    return { x, y };
                });
                dragStartPos.current = { x: e.clientX, y: e.clientY };
            }
        };

        const handleMouseUp = () => {
            setIsDragging(false);
        };

        if (isDragging) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
        } else {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        }
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging]);

    const handleCheckClose = async (e) => {
        const result = onCloseCheck ? await onCloseCheck() : true;
        if (result && onClose) {
            onClose(e);
        }
    }

    const handleClose = async (e) => {
        if (e.target !== e.currentTarget) {
            return;
        }
        if (isCloseOut) {
            await handleCheckClose(e);
        }
    };

    if (!isOpen) {
        return null;
    }

    return (
        <div className={`popup ${isAbsoluteDisplay ? '-is-absolute' : ''}`} onClick={handleClose}>
            <motion.div
                ref={modalRef}
                key="modalContent"
                initial={isWidget ? { opacity: 0 } : {}}
                animate={isWidget ? { opacity: 1 } : {}}
                exit={isWidget ? { opacity: 0} : {}}
                transition={isWidget ? { duration: 0.2, delay: isOpen ? 0.2 : 0 } : {}}
                className={`popup-container`}
                style={{ ...modalPosition, transform: `translate(${modalPosition.x}px, ${modalPosition.y}px)` }}
            >
                {onClose && (
                    <div className="popup-close-button" onClick={handleCheckClose}>
                        <Close />
                    </div>
                )}
                <div className={`popup-header`}>
                    {header}
                    {title && (
                        <div
                            className={`popup-title ${isMoving && !tabletView ? '-isMoving' : ''}`}
                            onMouseDown={handleMouseDown}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {title}
                        </div>
                    )}
                </div>
                <div className="popup-content scrollable" onClick={(e) => e.stopPropagation()}>{children}</div>
            </motion.div>
        </div>
    );
};
